import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useOccupation } from '../features/occupation/hook'
import CreatableSelect from 'react-select/creatable';
import { TagItems } from './tag-items';
import { useSelector } from 'react-redux';

const placeholder = {
  en: 'Search or type occupation',
  id: 'Cari atau ketik pekerjaan'
}

const OccupationAdder = ({ data, onChange, noPreview, isDisabled = false }) => {
  const { occupationOptions } = useOccupation()
  const [selectValue, setSelectValue] = useState(null)
  const [selectOptions, setSelectOptions] = useState(occupationOptions)
  const { language } = useSelector(state => state.system)

  const addItem = (value, { action }) => {
    if (action === 'select-option' || action === 'create-option') {
      if(!noPreview){
        const newData = [
          ...data,
          value
        ]

        onChange(newData)
        setSelectValue(null)
      } else {
        onChange([value])
        setSelectValue(value)
      }
    }
  }

  const removeItem = (e) => {
    console.log(e)
    if(e){
      const { value } = e
      const newData = data.filter((item) => {
        return item.value !== value
      })

      if(!noPreview){
        onChange(newData)
        setSelectValue(null)
      } else {
        onChange([value])
        setSelectValue(value)
      }
    }
  }

  // When data updated, disabled the selected data inside select options
  useEffect(() => {
    if(data && !noPreview){
      const selectedIds = data.map(v => v.value)
      const updatedSelectOptions = selectOptions.map((option) => {
        return {
          ...option,
          isDisabled: selectedIds.includes(option.value)
        }
      })
      setSelectOptions(updatedSelectOptions)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  useEffect(() => {
    setSelectOptions(occupationOptions)
  }, [occupationOptions])

  useEffect(() => {
    if(data && data.length > 0){
      setSelectValue(data[0])
    }
    // eslint-disable-next-line
  }, [])

  return (
    <div>
      {
        !noPreview &&
        <TagItems
          data={data}
          onRemove={removeItem}
        />
      }

      <CreatableSelect
        className="text-sm"
        options={selectOptions}
        value={selectValue}
        placeholder={placeholder[language.name]}
        onChange={addItem}
        isDisabled={isDisabled}
      />
    </div>
  )
}

OccupationAdder.propTypes = {
  data: PropTypes.array,
  onChange: PropTypes.func
}

OccupationAdder.defaultProps = {
  data: [],
  onChange: () => {}
}

export { OccupationAdder }
